// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  RenderStatus,
} from "./types";


export default __t.row({
  id: __t.u64().primaryKey(),
  project: __t.string(),
  requestedBy: __t.identity().name("requested_by"),
  get status() {
    return RenderStatus;
  },
  prompt: __t.string(),
  style: __t.string(),
  contextJson: __t.string().name("context_json"),
  quality: __t.string(),
  size: __t.string(),
  sourceBlobPath: __t.string().name("source_blob_path"),
  blobPath: __t.string().name("blob_path"),
  error: __t.string(),
  costUsdMilli: __t.u64().name("cost_usd_milli"),
  requestedAt: __t.timestamp().name("requested_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
